import script from "./WorkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkPage.vue?vue&type=script&setup=true&lang=js"

import "./WorkPage.vue?vue&type=style&index=0&id=3dd4ee39&scoped=true&lang=css"
import "../css/general-style.css?vue&type=style&index=1&lang=css&external"
import "../css/workStyle.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd4ee39"]])

export default __exports__